import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import VBox from 'components/common/VBox';
import HBox from 'components/common/HBox';
import FocusableButton from 'components/common/FocusableButton';
import Input from 'components/common/Input';
import SelectButton from 'components/common/SelectButton';
import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import useForm from 'hooks/common/useForm';
import { fromFormat, luxonClone } from 'utils/time';
import * as Luxon from 'luxon';
import Circle from 'components/common/Circle';
import CpfRatioBox from '../pages/Report/ReportDiet/CpfRatioBox';
import BloodGlocoseDialogChart from '../charts/BloodGlocoseDialogChart';
import BloodGlocoseDialogGlocoseTable from './BloodGlocoseDialogGlocoseTable';
import BloodGlocoseDialogDietTable from './BloodGlocoseDialogDietTable';
import BloodGlocoseDialogExerciseTable from './BloodGlocoseDialogExerciseTable';
import BloodGlocoseDialogInsulinTable from './BloodGlocoseDialogInsulinTable';
import usePopupBloodSugar from 'hooks/communication/usePopupBloodSugar';
import CHECK_COLORS from 'constants/CHECK_COLORS';
import WEEK_DAY_COLUMNS from 'constants/WEEK_DAY_COLUMNS';

const M = ({ count }) => (
  <VBox {...ex('GlocoseIcon')}>
    <svg width={32} height={33} viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.855469" y="0.5" width="30.941" height={32} rx={4} fill="#F4F4F4" />
      <mask id="mask0_943_7091" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x={4} y={5} width={24} height={25}>
        <rect x="4.72314" y="5.5" width="23.2058" height={24} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_943_7091)">
        <path d="M11.4915 27.5V18.35C10.6697 18.1167 9.98075 17.65 9.42478 16.95C8.86881 16.25 8.59082 15.4333 8.59082 14.5V7.5H10.5246V14.5H11.4915V7.5H13.4254V14.5H14.3923V7.5H16.3261V14.5C16.3261 15.4333 16.0481 16.25 15.4921 16.95C14.9361 17.65 14.2472 18.1167 13.4254 18.35V27.5H11.4915ZM21.1606 27.5V19.5H18.2599V12.5C18.2599 11.1167 18.7313 9.9375 19.674 8.9625C20.6167 7.9875 21.7569 7.5 23.0944 7.5V27.5H21.1606Z" fill="#909090" />
      </g>
    </svg>

    <div>
      {count}
    </div>
  </VBox>
);
const A = ({ count }) => (
  <VBox {...ex('GlocoseIcon')}>
    <svg width={32} height={33} viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.651367" y="0.5" width="30.941" height={32} rx={4} fill="#F4F4F4" />
      <mask id="mask0_943_7090" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x={4} y={4} width={24} height={25}>
        <rect x="4.51904" y="4.5" width="23.2058" height={24} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_943_7090)">
        <path d="M17.0887 27.5V21.5L15.0582 19.5L14.0913 23.9L7.41968 22.5L7.80644 20.5L12.4476 21.5L13.9946 13.4L12.2542 14.1V17.5H10.3204V12.8L14.1397 11.1C14.7037 10.85 15.1187 10.6875 15.3846 10.6125C15.6505 10.5375 15.8962 10.5 16.1218 10.5C16.4603 10.5 16.7745 10.5917 17.0646 10.775C17.3546 10.9583 17.5883 11.2 17.7656 11.5L18.7325 13.1C19.1515 13.8 19.7195 14.375 20.4367 14.825C21.1538 15.275 21.9716 15.5 22.8902 15.5V17.5C21.8266 17.5 20.8315 17.2708 19.9049 16.8125C18.9782 16.3542 18.2007 15.75 17.5722 15L16.9921 18L19.0226 20V27.5H17.0887ZM17.5722 10C17.0404 10 16.5851 9.80417 16.2064 9.4125C15.8277 9.02083 15.6384 8.55 15.6384 8C15.6384 7.45 15.8277 6.97917 16.2064 6.5875C16.5851 6.19583 17.0404 6 17.5722 6C18.104 6 18.5593 6.19583 18.938 6.5875C19.3167 6.97917 19.506 7.45 19.506 8C19.506 8.55 19.3167 9.02083 18.938 9.4125C18.5593 9.80417 18.104 10 17.5722 10Z" fill="#909090" />
      </g>
    </svg>

    <div>
      {count}
    </div>
  </VBox>
);
const I = ({ count }) => (
  <VBox {...ex('GlocoseIcon')}>
    <svg width={32} height={33} viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.382568" y="0.5" width="30.941" height={32} rx={4} fill="#F4F4F4" />
      <mask id="mask0_943_7093" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x={4} y={5} width={24} height={25}>
        <rect width="23.2058" height={24} transform="matrix(-1 0 0 1 27.4561 5.5)" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_943_7093)">
        <path d="M23.685 16.675C23.8623 16.475 23.9509 16.2375 23.9509 15.9625C23.9509 15.6875 23.8623 15.45 23.685 15.25L20.9777 12.45L22.0171 11.375L22.3072 11.675C22.5006 11.875 22.7302 11.975 22.9961 11.975C23.262 11.975 23.4916 11.875 23.685 11.675C23.8623 11.4916 23.9509 11.2583 23.9509 10.975C23.9509 10.6916 23.8623 10.4583 23.685 10.275L21.7512 8.27495C21.5578 8.07495 21.3282 7.97495 21.0623 7.97495C20.7964 7.97495 20.5668 8.07495 20.3734 8.27495C20.1961 8.45828 20.1075 8.69162 20.1075 8.97495C20.1075 9.25828 20.1961 9.49162 20.3734 9.67495L20.6634 9.97495L19.624 11.05L16.9167 8.24995C16.7233 8.04995 16.4937 7.94995 16.2278 7.94995C15.9619 7.94995 15.7322 8.04995 15.5388 8.24995C15.3455 8.44995 15.2488 8.68745 15.2488 8.96245C15.2488 9.23745 15.3455 9.47495 15.5388 9.67495L16.1915 10.325L9.06056 17.7C8.68991 18.0833 8.50459 18.5541 8.50459 19.1125C8.50459 19.6708 8.68991 20.1416 9.06056 20.525L9.73739 21.25L5.16876 25.95H7.92444L11.1152 22.65L11.7921 23.375C12.1627 23.7583 12.618 23.95 13.1578 23.95C13.6977 23.95 14.1529 23.7583 14.5236 23.375L21.6545 16L22.3072 16.675C22.5006 16.8583 22.7302 16.95 22.9961 16.95C23.262 16.95 23.4916 16.8583 23.685 16.675ZM20.3009 14.6L13.1699 21.975L10.4384 19.125L11.8888 17.6L13.2424 19C13.4358 19.1833 13.6655 19.2791 13.9314 19.2875C14.1973 19.2958 14.4188 19.2083 14.5961 19.025C14.7895 18.825 14.8862 18.5875 14.8862 18.3125C14.8862 18.0375 14.7895 17.8 14.5961 17.6L13.2424 16.2L14.6928 14.7L16.0465 16.1C16.2398 16.2833 16.4695 16.375 16.7354 16.375C17.0013 16.375 17.2309 16.2833 17.4243 16.1C17.6016 15.9 17.6902 15.6625 17.6902 15.3875C17.6902 15.1125 17.6016 14.875 17.4243 14.675L16.0706 13.275L17.5452 11.75L20.3009 14.6Z" fill="#909090" />
      </g>
    </svg>

    <div>
      {count}
    </div>
  </VBox>
);

const icons = { M, I };
export default function BloodGlocoseDialog(props) {
  const {
    index,
    count,
    onPrev,
    onNext,
    events,
    start_time,
    end_time,
    type,
    ...rest
  } = props;

  const {
    requestPopupBloodSugar,
  } = usePopupBloodSugar();

  const [data, setData] = React.useState({ uninitialized: true });

  const {
    bldsugr_graph_list = [],
    event_list = [],
    // bld_sugr_time,
    // bld_sugr_value,
    // max_bld_sugr_yn,
    max_bldsugr_time,
    min_bldsugr_time,
    max_bldsugr,
    min_bldsugr,
    postprand2h_max_bldsugr_time,
    postprand2h_max_bldsugr_time_zone_tp_cd,
    bldsugr_before_meal,
    postprand2h_max_bldsugr,
    postprand2h_bldsugr,
    postprand2h_bldsugr_rise_w,
    postprand2h_bldsugr_tp,
    postprand_abnrml_bldsugr_min,
    main_food_list = [],
    // intaken_time,
    // main_food_nm,
    // main_food_cal,
    total_intaken_cal,
    carbo_rate,
    protein_rate,
    fat_rate,
    postprand_active_time,
    postprand_step_cnt,
    postprand_burn_cal,
    bolus_cnt,
    bolus_amt,
    bolus_time,
    abnrml_time_inout_yn = 'N',
    graph_start_time,
    graph_end_time,
  } = data;

  const event_hash = React.useMemo(() => {
    return event_list.reduce((a, c) => ({
      ...a,
      [c.event_icon_time]: (a[c.event_icon_time] || 0) + 1,
    }), {});
  }, [event_list]);

  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);

  React.useEffect(() => {
    requestPopupBloodSugar({
      patient_no,
      search_start_time: start_time,
      search_end_time: end_time,
      bld_sugr_tp_cd: type === 'max' ? 'H' : 'L',
    }, (success, data) => {
      if (success) {
        setData(() => data);
      } else {
        setData(() => ({ error: true }));
      }
    });
  }, [end_time, events, patient_no, requestPopupBloodSugar, start_time, type]);

  const luxon = React.useMemo(() => !start_time ? Luxon.DateTime.now() : fromFormat(start_time, 'yyyyMMddHHmmss'), [start_time]);
  const [date, weekday] = React.useMemo(() => [luxon.toFormat('yy.MM.dd'), luxonClone(luxon).weekday], [luxon]);

  const [startTime, endTime, maxTime, maxValue, maxTimeString, minTime, minValue, minTimeString] = React.useMemo(() => {
    if (!bldsugr_graph_list.length) return [0, 0, 0, 0, '', 0, 0, ''];
    let maxTime = bldsugr_graph_list[0].bld_sugr_time || '';
    let maxValue = bldsugr_graph_list[0].bld_sugr_value;
    let minTime = bldsugr_graph_list[0].bld_sugr_time || '';
    let minValue = bldsugr_graph_list[0].bld_sugr_value;
    bldsugr_graph_list.forEach((item) => {
      if (maxValue < item.bld_sugr_value) {
        maxTime = item.bld_sugr_time;
        maxValue = item.bld_sugr_value;
      }
      if (item.bld_sugr_value < minValue) {
        minTime = item.bld_sugr_time;
        minValue = item.bld_sugr_value;
      }
    });
    return [
      !graph_start_time ? fromFormat(maxTime, 'HHmm').toMillis() : fromFormat(graph_start_time, 'yyyyMMddHHmmss').toMillis(),
      !graph_end_time ? fromFormat(minTime, 'HHmm').toMillis() : fromFormat(graph_end_time, 'yyyyMMddHHmmss').toMillis(),
      fromFormat(maxTime, 'HHmm').toMillis(),
      maxValue,
      maxTime,
      fromFormat(minTime, 'HHmm').toMillis(),
      minValue,
      minTime
    ];
  }, [bldsugr_graph_list, graph_end_time, graph_start_time]);
  const [chartInfo, setChartRect] = React.useState({
    left: 0,
    width: 0,
    top: 0,
    height: 0,
    time: '',
    max: 0,
    min: 0,
  });
  const onChangeChartInfo = React.useCallback((chartInfo) => {
    setChartRect(() => chartInfo);
  }, []);


  const stime = React.useMemo(() => data[`${type}_bldsugr_time`] ? fromFormat(data[`${type}_bldsugr_time`], 'yyyyMMddHHmmss') : Luxon.DateTime.now(), [data, type]);

  const value = type === 'max' ? max_bldsugr : type === 'min' ? min_bldsugr : '';
  const timeString = type === 'max' ? max_bldsugr_time : type === 'min' ? min_bldsugr_time : '';
  // const timeLuxon = React.useMemo(() => !timeString ? Luxon.DateTime.now() : fromFormat(timeString, 'yyyyMMddHHmmss'), [timeString]);
  const timeLuxon = React.useMemo(() => {
    if (!stime || !bldsugr_graph_list.length) {
      return Luxon.DateTime.now();
    } else {
      return stime;
    }
  }, [bldsugr_graph_list, stime]);

  const time = timeLuxon.toMillis();
  const top = chartInfo[type] || 0;
  const hour = +timeLuxon.hour || 0;
  const min = timeLuxon.minute || '';
  const isPm = 12 <= hour;
  if (data?.uninitialized) {
    return (
      <VBox
        {...ex(['Dialog', 'BloodGlocoseDialog'], rest)}
      >
        <HBox {...ex('DialogTitle')}>
          <div>
            {T('혈당 기록 | {0} ({1})', date, WEEK_DAY_COLUMNS[weekday - 1])}
          </div>
          <div>
            <FocusableButton
              {...{
                onClick: events?.onClose,
              }}
            >
              <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M6.29279 6.29308C6.48031 6.10561 6.73462 6.00029 6.99979 6.00029C7.26495 6.00029 7.51926 6.10561 7.70679 6.29308L11.9998 10.5861L16.2928 6.29308C16.385 6.19757 16.4954 6.12139 16.6174 6.06898C16.7394 6.01657 16.8706 5.98898 17.0034 5.98783C17.1362 5.98668 17.2678 6.01198 17.3907 6.06226C17.5136 6.11254 17.6253 6.18679 17.7192 6.28069C17.8131 6.37458 17.8873 6.48623 17.9376 6.60913C17.9879 6.73202 18.0132 6.8637 18.012 6.99648C18.0109 7.12926 17.9833 7.26048 17.9309 7.38249C17.8785 7.50449 17.8023 7.61483 17.7068 7.70708L13.4138 12.0001L17.7068 16.2931C17.8889 16.4817 17.9897 16.7343 17.9875 16.9965C17.9852 17.2587 17.88 17.5095 17.6946 17.6949C17.5092 17.8803 17.2584 17.9855 16.9962 17.9878C16.734 17.99 16.4814 17.8892 16.2928 17.7071L11.9998 13.4141L7.70679 17.7071C7.51818 17.8892 7.26558 17.99 7.00339 17.9878C6.74119 17.9855 6.49038 17.8803 6.30497 17.6949C6.11956 17.5095 6.01439 17.2587 6.01211 16.9965C6.00983 16.7343 6.11063 16.4817 6.29279 16.2931L10.5858 12.0001L6.29279 7.70708C6.10532 7.51955 6 7.26525 6 7.00008C6 6.73492 6.10532 6.48061 6.29279 6.29308Z" fill="#5B6871" />
              </svg>
            </FocusableButton>
          </div>
        </HBox>
        <HBox {...ex('DialogEmpty')}>
        </HBox>
      </VBox>
    );
  } else if (data?.error) {
    return (
      <VBox
        {...ex(['Dialog', 'BloodGlocoseDialog'], rest)}
      >
        <HBox {...ex('DialogTitle')}>
          <div>
            {T('혈당 기록 | {0} ({1})', date, WEEK_DAY_COLUMNS[weekday - 1])}
          </div>
          <div>
            <FocusableButton
              {...{
                onClick: events?.onClose,
              }}
            >
              <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M6.29279 6.29308C6.48031 6.10561 6.73462 6.00029 6.99979 6.00029C7.26495 6.00029 7.51926 6.10561 7.70679 6.29308L11.9998 10.5861L16.2928 6.29308C16.385 6.19757 16.4954 6.12139 16.6174 6.06898C16.7394 6.01657 16.8706 5.98898 17.0034 5.98783C17.1362 5.98668 17.2678 6.01198 17.3907 6.06226C17.5136 6.11254 17.6253 6.18679 17.7192 6.28069C17.8131 6.37458 17.8873 6.48623 17.9376 6.60913C17.9879 6.73202 18.0132 6.8637 18.012 6.99648C18.0109 7.12926 17.9833 7.26048 17.9309 7.38249C17.8785 7.50449 17.8023 7.61483 17.7068 7.70708L13.4138 12.0001L17.7068 16.2931C17.8889 16.4817 17.9897 16.7343 17.9875 16.9965C17.9852 17.2587 17.88 17.5095 17.6946 17.6949C17.5092 17.8803 17.2584 17.9855 16.9962 17.9878C16.734 17.99 16.4814 17.8892 16.2928 17.7071L11.9998 13.4141L7.70679 17.7071C7.51818 17.8892 7.26558 17.99 7.00339 17.9878C6.74119 17.9855 6.49038 17.8803 6.30497 17.6949C6.11956 17.5095 6.01439 17.2587 6.01211 16.9965C6.00983 16.7343 6.11063 16.4817 6.29279 16.2931L10.5858 12.0001L6.29279 7.70708C6.10532 7.51955 6 7.26525 6 7.00008C6 6.73492 6.10532 6.48061 6.29279 6.29308Z" fill="#5B6871" />
              </svg>
            </FocusableButton>
          </div>
        </HBox>
        <HBox {...ex('DialogEmpty')}>
          {T('혈당 기록 데이터가 없습니다.')}
        </HBox>
      </VBox>
    );
  } else {
    return (
      <VBox
        {...ex(['Dialog', 'BloodGlocoseDialog', type], rest)}
      >
        <HBox {...ex('DialogTitle')}>
          <div>
            {T('혈당 기록 | {0} ({1})', date, WEEK_DAY_COLUMNS[weekday - 1])}
          </div>
          <div>
            <FocusableButton
              {...{
                onClick: events?.onClose,
              }}
            >
              <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M6.29279 6.29308C6.48031 6.10561 6.73462 6.00029 6.99979 6.00029C7.26495 6.00029 7.51926 6.10561 7.70679 6.29308L11.9998 10.5861L16.2928 6.29308C16.385 6.19757 16.4954 6.12139 16.6174 6.06898C16.7394 6.01657 16.8706 5.98898 17.0034 5.98783C17.1362 5.98668 17.2678 6.01198 17.3907 6.06226C17.5136 6.11254 17.6253 6.18679 17.7192 6.28069C17.8131 6.37458 17.8873 6.48623 17.9376 6.60913C17.9879 6.73202 18.0132 6.8637 18.012 6.99648C18.0109 7.12926 17.9833 7.26048 17.9309 7.38249C17.8785 7.50449 17.8023 7.61483 17.7068 7.70708L13.4138 12.0001L17.7068 16.2931C17.8889 16.4817 17.9897 16.7343 17.9875 16.9965C17.9852 17.2587 17.88 17.5095 17.6946 17.6949C17.5092 17.8803 17.2584 17.9855 16.9962 17.9878C16.734 17.99 16.4814 17.8892 16.2928 17.7071L11.9998 13.4141L7.70679 17.7071C7.51818 17.8892 7.26558 17.99 7.00339 17.9878C6.74119 17.9855 6.49038 17.8803 6.30497 17.6949C6.11956 17.5095 6.01439 17.2587 6.01211 16.9965C6.00983 16.7343 6.11063 16.4817 6.29279 16.2931L10.5858 12.0001L6.29279 7.70708C6.10532 7.51955 6 7.26525 6 7.00008C6 6.73492 6.10532 6.48061 6.29279 6.29308Z" fill="#5B6871" />
              </svg>
            </FocusableButton>
          </div>
        </HBox>
        <HBox full>
          <VBox full>
            <VBox {...ex('ChartArea')}>
              <BloodGlocoseDialogChart {...{ bldsugr_graph_list, value, onChangeChartInfo, type, stime }} />
              {abnrml_time_inout_yn === 'Y' && (
                <div
                  {...ex('KeyTime')}
                  {...{
                    style: chartInfo,
                  }}
                >
                  <div
                    {...ex('Time')}
                    {...{
                      style: {
                        left: `${(time - startTime) / (endTime - startTime) * 100}%`,
                      }
                    }}
                  />
                  <div
                    {...ex('Label')}
                    {...{
                      style: {
                        left: `${(time - startTime) / (endTime - startTime) * 100}%`,
                        top,
                      }
                    }}
                  >
                    <div {...ex('Circle')} />
                    <VBox>
                      <HBox>
                        <div {...ex(['BASE_COLOR', CHECK_COLORS('B', value)])}>
                          {value}
                        </div>
                        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_2287_6606)">
                            <path fillRule="evenodd" clipRule="evenodd" d="M11.775 3.25C7.16462 3.25 3.35596 7.12752 3.35596 12C3.35596 16.8725 7.16462 20.75 11.775 20.75C16.3854 20.75 20.1941 16.8725 20.1941 12C20.1941 7.12752 16.3854 3.25 11.775 3.25ZM0.855957 12C0.855957 5.82678 5.70527 0.75 11.775 0.75C17.8448 0.75 22.6941 5.82678 22.6941 12C22.6941 18.1732 17.8448 23.25 11.775 23.25C5.70527 23.25 0.855957 18.1732 0.855957 12ZM11.775 6.75C12.1138 6.75 12.4381 6.88754 12.6737 7.13111L16.5413 11.1311C17.0212 11.6274 17.0078 12.4188 16.5115 12.8986C16.0152 13.3785 15.2239 13.3652 14.744 12.8689L13.025 11.0911V16C13.025 16.6904 12.4654 17.25 11.775 17.25C11.0847 17.25 10.525 16.6904 10.525 16V11.0911L8.80603 12.8689C8.32615 13.3652 7.53481 13.3785 7.03851 12.8986C6.54221 12.4188 6.5289 11.6274 7.00877 11.1311L10.8764 7.13111C11.1119 6.88754 11.4362 6.75 11.775 6.75Z" fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0_2287_6606">
                              <rect width="23.2058" height={24} fill="white" transform="translate(0.172363)" />
                            </clipPath>
                          </defs>
                        </svg>
                      </HBox>
                      <div>
                        {stime.toFormat('HH:mm')}
                        {/* {T('{0} {1}:{2}', isPm ? T('오후') : T('오전'), hour === 12 ? 12 : (hour % 12).toString().padStart(2, '0'), min)} */}
                      </div>
                    </VBox>
                  </div>
                </div>
              )}
              <HBox center {...ex('GlocoseTags', { style: { marginLeft: chartInfo.left } })}>
                {event_list.map((e, index) => {
                  const {
                    event_icon_cd,
                    event_icon_cnt,
                    event_icon_time,
                  } = e;
                  const Icon = icons[event_icon_cd];
                  if (!Icon) return null;
                  const time = fromFormat(event_icon_time, 'yyyyMMddHHmmss').toMillis();
                  const ratio = (time - startTime) / (endTime - startTime);
                  if (1 < ratio) return null;
                  const top = 5;
                  const left = + (ratio * 100) + '%';

                  const count = 1 < event_hash[event_icon_time] ? (event_icon_cnt.toString() + '+') : event_icon_cnt;
                  return (
                    <div key={index} {...ex('GlocoseTag', { style: { top, left } })}>
                      <Icon {...{ count }} />
                    </div>
                  );
                })}
              </HBox>
            </VBox>
            <BloodGlocoseDialogGlocoseTable {...{ data, type, timeLuxon }} />
          </VBox>

          <VBox full>
            <VBox>
              <HBox {...ex('Caption')}>
                {T('식사')}
              </HBox>
              <BloodGlocoseDialogDietTable {...{ data }} />
            </VBox>
            <VBox>
              <HBox {...ex('Caption')}>
                {T('활동')}
              </HBox>
              <BloodGlocoseDialogExerciseTable {...{ data }} />
            </VBox>
            <VBox>
              <HBox {...ex('Caption')}>
                {T('인슐린')}
              </HBox>
              <BloodGlocoseDialogInsulinTable {...{ data }} />
            </VBox>
          </VBox>
        </HBox>
      </VBox >
    );
  }
}
